<template>
  <v-list-item v-if="contact"
               :class="[isSelected ? 'selectedIndicator' : 'pr-4']">
    <ContactTemplate :Contact="contact" />
    <v-scroll-x-transition>
      <v-list-item-action v-if="hasBeenSelected || starred">
        <v-icon v-if="hasBeenSelected"
                color="quaternary">mdi-check</v-icon>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-if="starred"
                    v-bind="attrs"
                    v-on="on"
                    color="primary">mdi-star</v-icon>
          </template>
          <span v-text="$t('servicesystem.common_objects.commonterms.default')" />
        </v-tooltip>
      </v-list-item-action>
    </v-scroll-x-transition>
  </v-list-item>
</template>


<script>
import ContactTemplate from "@/components/Preview/Customer/ContactTemplate.vue";

export default {
  name: "CustomerContactListItem",
  props: {
    contact: Object,
    preselected: Object,
    starred: Boolean,
    singleline: Boolean,
  },
  components: { ContactTemplate },
  data: () => ({}),

  mounted() {
    
  },

  methods: {},

  computed: {
    isSelected() {
      if (this.preselected && this.preselected.Id === this.contact.Id) {
        return true;
      } else {
        return false;
      }
    },

    hasBeenSelected() {
      if (this.preselected === this.contact.Id) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.selectedIndicator {
  background-color: rgb(249, 249, 249) !important;
  z-index: 2;
  border: 1px solid #427aaf;
  border-left: 8px solid #427aaf;
  border-right: none;
}
.selectedIndicator.right {
  border-left: none !important;
  border-right: 8px solid #427aaf !important;
}
</style>